/**
 * Expert View Toggle
 * 
 * Button to switch between human-friendly and technical terminology.
 * Positioned in the portal header for easy access.
 */

import { useExpertView } from '../../context/ExpertViewContext';
import './ExpertViewToggle.css';

export function ExpertViewToggle() {
  const { isExpertView, toggleExpertView } = useExpertView();

  return (
    <button
      onClick={toggleExpertView}
      className={`expert-view-toggle ${isExpertView ? 'expert-view-toggle--active' : ''}`}
      aria-label={isExpertView ? "Switch to friendly view" : "Switch to expert view"}
      title={isExpertView ? "Show user-friendly labels" : "Show technical terminology"}
    >
      <span aria-hidden="true" className="expert-view-toggle__icon">
        {isExpertView ? '🔬' : '👤'}
      </span>
      <span className="expert-view-toggle__text">
        {isExpertView ? 'Expert View: ON' : 'Expert View: OFF'}
      </span>
    </button>
  );
}
